export enum TaskType {
  Default = 'Default',
  MajorService = 'MajorService',
  PreventativeMaintenance = 'PreventativeMaintenance',
  Brakes = 'Brakes',
  ContainerInspection = 'ContainerInspection',
}

export enum IntervalType {
  Hours = 'Hours',
  Kilometres = 'Kilometres',
  Months = 'Months',
  Days = 'Days'
}

export enum ConfigurationType {
  Chassis = 'Chassis',
  Body = 'Body',
  Brake = 'Brake',
  Container = 'Container',
  Auxiliary = 'Auxiliary',
  Axle = 'Axle',
}

export enum MonthEventType {
  PreventativeMaintenance = 'PM',
  MajorService = 'Major',
  Defect = 'Defects due',
  DateBasedTask = 'Date-Based',
  BrakeCheck = 'Brake Check',
  Campaign = 'Campaign',
  CompletedDefects = 'Defects completed',
  ContainerInspection = 'Container Inspection',
}

export enum UnitType {
  Vehicle = 'Vehicle',
  Container = 'Container',
}

export enum DecommissionReason {
  Scrapped = 'Scrapped',
  Sold = 'Sold',
  Missing = 'Missing',
  Other = 'Other'
}

export enum DocumentType {
  ServiceSheet = 'ServiceSheet',
  NMICertificate = 'NMICertificate',
  Other = 'Other'
}

export enum DocumentRequirementType {
  NotApplicable = 'NotApplicable',
  Optional = 'Optional',
  Required = 'Required',
}

export enum WarrantyIntervalType {
  Months = 'Months',
  Years = 'Years',
}
